<div class="card card-default">
  <div class="card-header">
    <h3 class="card-title">Criteria</h3>

    <div class="card-tools">
      <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i></button>

    </div>
  </div>
  <!-- /.card-header -->
  <div class="card-body">
    <div class="row">
      <div class="col-lg-6">
        <div class="form-group">
          <label class="col-lg-4 control-label"> <b translate>Member No</b></label>

          <div class="col-lg-8">
            <input type="text" id="txtID" class="form-control" />
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label class="col-lg-4 control-label"> <b translate>ชื่อ-สกุล สมาชิก</b></label>

          <div class="col-lg-8">
            <input type="text" id="txtName" class="form-control" />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="form-group">
          <label class="col-lg-4 control-label"> <b translate>Member Type</b></label>

          <div class="col-lg-8">
            <select id="ddlMemberType" class="form-control">
            </select>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="form-group">
          <label class="col-lg-4 control-label"> <b translate>สถานะ</b></label>

          <div class="col-lg-8">
            <select id="ddlStatus" class="form-control">
              <option value="" selected translate>ทั้งหมด</option>
              <option value="1" translate>ใช้งาน</option>
              <option value="0" translate>ไม่ใช้งาน</option>
            </select>
          </div>
        </div>
      </div>

    </div>

  </div>
  <!-- /.card-body -->
  <div class="card-footer">
    <button type="button" class="btn btn-primary pull-right" (click)="BeforeSearch()" role="view" translate>
      <i class="fa  fa-search"></i>&nbsp;Search
    </button>
  </div>
</div>
<!-- /.card -->


<div class="card card-default">
  <div class="card-header">
    <h3 class="card-title">Data</h3>

    <div class="card-tools">
      <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i></button>

    </div>
  </div>
  <!-- /.card-header -->
  <div class="card-body">
    <div>
      <button type="button" class="btn btn-default" role="add" (click)="Add()" translate>
        <i class="fas fa-plus colorgreen"></i>&nbsp;เพิ่ม
      </button>
      <button type="button" class="btn btn-default" role="edit" (click)="Edit()" translate>
        <i class="fas fa-edit coloryellow"></i>&nbsp;แก้ไข
      </button>
    </div>
    <br />
    <table id="tData" class="table table-bordered  table-hover">
      <thead>
        <tr>
          <th width="15%" translate>รหัสสมาชิก</th>
          <th width="25%" translate>ชื่อ-นามสกุล</th>
          <th width="15%" translate>ประเภทสมาชิก</th>
          <th width="10%" translate>เพศ</th>
          <th width="10%" translate>เบอร์โทร</th>
          <th width="15%" translate>email</th>
          <th width="10%" translate>สถานะ</th>
          <th width="15%" translate>วันที่แก้ไข</th>
          <th width="10%" translate>ผู้แก้ไข</th>
          <th width="10%" translate>ลบ</th>
        </tr>
      </thead>
      <tbody>
      </tbody>
    </table>
  </div>

</div>


<div class="container">
  <div class="modal fade" id="dlgData" role="dialog">
    <div class="modal-dialog modal-xl">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">
            <span translate>Detail</span>
          </h4>
          <button type="button" class="close" id="btnCloseDlg" data-dismiss="modal">&times;</button>

        </div>
        <div class="modal-body">
          <input type="text" id="txtMode" class="form-control" style="display: none;" />
          <div class="form-horizontal" onsubmit="return false">
            <div id="divCusError" class="alert alert-danger" hidden="hidden">
              <button type="button" class="close" data-hide="alert">&times;</button>
              <strong translate>Error!</strong> <span id="spnCusError"></span>
            </div>
            <div class="row" style="display: none">
              <div class="col-lg-6">
                <div class="form-group">
                  <label class="col-lg-4 control-label"> <b translate>Picture</b></label>

                  <div class="col-lg-8">
                    <img class="profile-user-img img-responsive pull-left" id="imgMember"
                      style="width: 140px; height: 120px;" src="assets/images/Member/userdefault.jpg" alt="User">
                  </div>
                </div>

              </div>
            </div>

            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <label class="col-lg-4 control-label required"> <b translate>รหัสสมาชิก</b></label>

                  <div class="col-lg-8">
                    <input type="text" id="txtDlgID" required class="form-control" />
                  </div>
                </div>

              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label class="col-lg-4 control-label "> <b translate>Password</b></label>

                  <div class="col-lg-8">
                    <input type="password" id="txtDlgPassword" class="form-control" />
                  </div>
                </div>

              </div>
            </div>

            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <label class="col-lg-4 control-label required"> <b translate>Name</b></label>

                  <div class="col-lg-8">
                    <input type="text" id="txtDlgName" required class="form-control" />
                  </div>
                </div>

              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label class="col-lg-4 control-label required"> <b translate>นามสกุล</b></label>
                  <div class="col-lg-8">
                    <input type="text" id="txtDlgSurname" required class="form-control" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <label class="col-lg-4 control-label required"> <b translate>Member Type</b></label>
                  <div class="col-lg-8">
                    <select id="ddlDlgMemberType" required class="form-control">
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label class="col-lg-4 control-label required"> <b translate>Sex</b></label>

                  <div class="col-lg-8">
                    <select type="text" id="ddlDlgSex" required class="form-control">
                      <option value="M">ชาย</option>
                      <option value="F">หญิง</option>
                    </select>
                  </div>
                </div>

              </div>
              <div class="col-lg-6" style="display: none">
                <div class="form-group">
                  <label class="col-lg-4 control-label "> <b translate>Expire Date</b></label>
                  <div class="col-lg-8">
                    <input type="text" id="txtDlgExpireDate" value="31/12/2600" class="custom-text-horizon-rangdate2"
                      style="text-align: center;" maxlength="10"  data-provide="datepicker" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6" style="display: none">
                <div class="form-group">
                  <label class="col-lg-4 control-label "> <b translate>Birth Date</b></label>

                  <div class="col-lg-4">
                    <input type="text" id="txtDlgBirthDate" class="form-control" style="text-align: center;"
                      maxlength="10" data-provide="datepicker" />
                  </div>
                </div>

              </div>

            </div>
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <label class="col-lg-4 control-label"> <b translate>Tel</b></label>

                  <div class="col-lg-8">
                    <input type="text" id="txtDlgTel" class="form-control" />
                  </div>
                </div>

              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label class="col-lg-4 control-label"> <b translate>email</b></label>
                  <div class="col-lg-8">
                    <input type="text" id="txtDlgEmail" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row" style="display: none">
              <div class="col-lg-6">
                <div class="form-group">
                  <label class="col-lg-4 control-label"> <b translate>Position</b></label>

                  <div class="col-lg-8">
                    <select id="ddlDlgPosition" class="form-control">
                    </select>
                  </div>
                </div>

              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label class="col-lg-4 control-label"> <b translate>Department</b></label>
                  <div class="col-lg-8">
                    <select id="ddlDlgDepartMent" class="form-control">
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <label class="col-lg-4 control-label"> <b translate>Status</b></label>

                  <div class="col-lg-8">
                    <select id="ddlDlgStatus" class="form-control">
                      <option value="1" selected translate>ใช้งาน</option>
                      <option value="0" translate>ไม่ใช้งาน</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>




          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal" translate>Cancel</button>
          <button type="button" class="btn btn-primary " role="edit" (click)="Save()" translate>Save</button>
        </div>

      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/member/register/register.component.html